module.exports = __webpack_public_path__ + "static/img/img2-3.fb9a835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img2-3.png
// module id = 0QsR
// module chunks = 10